import Base from './Base'

class MvService extends Base {
  /**
   * @see http://impai.tmeoa.com/project/5238/interface/api/15706
   * @param {Object} postData
   */
  find(postData) {
    return this.post('mv/query_mv', postData, { noEmpty: true })
  }

  findById(postData) {
    return this.post('mv/query_mv_detail_by_id', postData)
  }

  save(postData) {
    return this.post('mv/save_mv', postData)
  }

  applyModify(postData) {
    return this.post('review/save_mv_modify_review', postData)
  }

  queryModify(postData) {
    return this.post('review/query_mv_modify_review', postData, { noEmpty: true })
  }

  reviewModify(postData) {
    return this.post('review/review_mv_modify', postData)
  }

  reviewEditReview(postData) {
    return this.post('review/edit_mv_modify_review', postData)
  }

  transReviewType(postData) {
    return this.post('review/move_mv_modify', postData)
  }
}

export default new MvService()
